export default __webpack_public_path__ + "assets/icon3-8943119.svg";